import React from 'react';
import { gql, useQuery } from '@apollo/client';
import DynamicScriptLoader from '../../../server/html/DynamicScriptLoader';
import { ERROR_MESSAGE, LOADING_MESSAGE } from '../../components/Messages/Messages';

const query = gql`
  query ReviewParams {
    reviewParams {
      BVInstance
      BVLocale
      BVEnvironment
      BVBrand
    }
  }
`;

export default function ReviewScript() {
  const { loading, error, data } = useQuery(query);

  if (loading) return LOADING_MESSAGE;
  if (error) return ERROR_MESSAGE;

  const scriptURL = `https://apps.bazaarvoice.com/deployments/${data.reviewParams.BVInstance}/${data.reviewParams.BVBrand}/${data.reviewParams.BVEnvironment}/${data.reviewParams.BVLocale}/bv.js`;

  return (
    <DynamicScriptLoader isAsync script={scriptURL} />
  );
}
